import { Deserializable } from '../../protocols/deserializable';

export class State implements Deserializable {
  stateCode!: string;
  countryId!: number;
  countryCode: string | null = null;
  countryName: string | null = null;
  id!: number;
  name!: string;

  onDeserialize() {}
}
